import React from "react";
import { useInView } from "react-intersection-observer";

import styles from "./index.module.scss";
import clsx from "clsx";

export interface NewEventsItemProps {
  title: string;
  time: string;
  image: string;
  link: string;
}

export function NewEventsItem(props: NewEventsItemProps) {
  const { ref, inView } = useInView({
    triggerOnce: true
  });

  return (
    <div
      className={clsx([
        styles.card,
        "animate__animated",
        { animate__fadeInDown: inView }
      ])}
      ref={ref}
    >
      <div>
        <a href={props.link}>
          <img src={props.image} alt={props.title} className={styles.image} />
        </a>
      </div>

      <div className={styles.content}>
        <div className={styles.title}>
          <a href={props.link} target="_blank">
            {props.title}
          </a>
        </div>
        <div className={styles.time}>{props.time}</div>
      </div>
    </div>
  );
}
